import { createContext, useContext, useState, useEffect, useCallback } from "react";
import { api } from "./api";

const PastorAuthContext = createContext(null);

export const PastorAuthProvider = ({ children }) => {
  const [pastor, setPastor] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/pastor/me");
      setPastor(data);
    } catch {
      setPastor(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    // If returning from Google OAuth, AuthCallback exchanges the session_id first.
    if (window.location.hash?.includes("session_id=")) { setLoading(false); return; }
    checkAuth();
  }, [checkAuth]);

  const login = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/account";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  const logout = async () => {
    await api.post("/auth/pastor/logout").catch(() => {});
    setPastor(null);
  };

  return (
    <PastorAuthContext.Provider value={{ pastor, loading, login, logout, setPastor }}>
      {children}
    </PastorAuthContext.Provider>
  );
};

export const usePastorAuth = () => useContext(PastorAuthContext);
